import { createDefaultCvDraft } from "@/lib/cvDraftContract";

export const CV_BUILDER_LOCAL_STORAGE_KEY = "cv_builder_draft";

export const readLocalDraft = () => {
  const saved = sessionStorage.getItem(CV_BUILDER_LOCAL_STORAGE_KEY);
  if (!saved) {
    return null;
  }
  return JSON.parse(saved);
};

export const writeLocalDraft = (draft) => {
  sessionStorage.setItem(CV_BUILDER_LOCAL_STORAGE_KEY, JSON.stringify(draft));
};

export const clearLocalDraft = () => {
  sessionStorage.removeItem(CV_BUILDER_LOCAL_STORAGE_KEY);
};

export const shouldPersistLocalDraft = (draft) => {
  return JSON.stringify(draft) !== JSON.stringify(createDefaultCvDraft());
};
